import React from 'react';
import { reportClientFailure } from '../util/clientDiagnostics';

export class GameErrorBoundary extends React.Component<{ children: React.ReactNode }, { failed: boolean; code: string }> {
  state = { failed: false, code: '' };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ code: reportClientFailure(error, info.componentStack) });
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return <div role="alert" style={{ position: 'fixed', inset: 0, zIndex: 2147483647, display: 'grid', placeItems: 'center', background: '#111b2d', color: '#fff', fontFamily: 'Tahoma, sans-serif', padding: 24 }}>
      <section style={{ maxWidth: 480, textAlign: 'center', lineHeight: 1.8 }}>
        <h2>เกิดปัญหาในการแสดงผลเกม</h2>
        <p>กรุณาโหลดเกมใหม่ หากเกิดซ้ำ ส่งรหัสด้านล่างให้ทีมงานตรวจสอบ</p>
        <p style={{ userSelect: 'all', color: '#b8d5ff' }}>{this.state.code || 'กำลังบันทึกข้อผิดพลาด…'}</p>
        <button onClick={() => window.location.reload()} style={{ padding: '12px 24px', cursor: 'pointer', borderRadius: 8, border: 0, background: '#4169ef', color: '#fff', fontSize: 16 }}>โหลดเกมใหม่</button>
      </section>
    </div>;
  }
}
